import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p className="copyright">© 2025 Julia Ilioukhina</p>
      </div>
    </footer>
  );
};

export default Footer; 